/* 
    Works like three.js clock with more control.
    Saves current time, elapsed time, delta time (time between current and last frame)
    triggers event on each frame (tick)
*/

import { EventDispatcher } from "three"


//let instanceCount = 0


export default class Time extends EventDispatcher{
    constructor(){
        super()
        //instanceCount++
        //this.id = instanceCount
        //console.log(`Time Class instantiated. ID: ${this.id}`)

        //console.log("Time Class")
        // Setup
        this.start = Date.now()
        this.current = this.start
        this.elapsed = 0
        this.delta = 16 //~16 milliseconds between 60fps prevents potential bug
        window.requestAnimationFrame(()=>{
            this.tick()
        })
    }

    tick(){
        const currentTime = Date.now()
        this.delta = currentTime - this.current
        this.current = currentTime
        this.elapsed = this.current - this.start
        
        this.dispatchEvent({
            type: 'tick',
            //message: 'dispatch tick event'
        })

        window.requestAnimationFrame(()=>{
            this.tick()
        })
    }
}